import createBaseService from "@/api/base-service.ts";
import type { Branch } from "../../types/branch";

const branchService = {
	...createBaseService<Branch>("/branches"),
};

export default branchService;
